export default __webpack_public_path__ + "static/media/icon_gorgias.2703e486.png";